import styled from 'styled-components';
import { fadeIn } from '../../../../../constants/keyframes/fades';
import theme from '../../../../../constants/theme';
import { sequencedAnimationDelay } from '../../../../../helpers/styleHelpers/styleHelpers';
import { A, asAnchor } from '../../../../base/typography';
import { H5 } from '../../../../base/typography/headings';

export const ResultItem = styled.div`
	padding: 2.5rem 0;
	border-bottom: 1px solid ${theme.colorsV2.grey5};
	opacity: 0;
	animation: ${fadeIn} 300ms linear forwards;
	${sequencedAnimationDelay(20, 0.05)};
`;

export const Headline = styled(H5)`
	margin-bottom: 12px;
`;

export const HeadlineLink = styled(A)`
	${asAnchor};
	font-size: 20px;
	color: ${theme.colorsV2.mainRed};
`;

export const Text = styled.p`
	margin-bottom: 0;
	padding: 0 0 0.5em;
	font-size: 18px;
	line-height: 25px;
	color: ${theme.colorsV2.grey7};
`;

export const UrlLink = styled(A)`
	font-size: 16px;
	font-family: ${theme.fonts.Arimo};
	color: ${theme.colorsV2.mainPink};

	&:hover {
		color: ${theme.colorsV2.mainPink};
	}
`;
